import imgArtisaniDesktop from '../assets/img/banners_parceiros_main_slider/artisani_desktop.jpg';
import imgChiccoDesktop from '../assets/img/banners_parceiros_main_slider/chicco_desktop.jpg';
import imgMercadaoDesktop from '../assets/img/banners_parceiros_main_slider/mercadao_desktop.jpg';
import imgPokeHouseDesktop from '../assets/img/banners_parceiros_main_slider/poke_house_desktop.png';
import imgPokeHouseTablet from '../assets/img/banners_parceiros_main_slider/poke_house_tablet.png';
import imgPokeHouseMobile from '../assets/img/banners_parceiros_main_slider/poke_house_mobile.png';
import imgAntarteDesktop from '../assets/img/banners_parceiros_main_slider/antarte_desktop.jpg';
import imgAntarteTablet from '../assets/img/banners_parceiros_main_slider/antarte_tablet.jpg';
import imgAntarteMobile from '../assets/img/banners_parceiros_main_slider/antarte_mobile.jpg';
import imgAntarteLogo from '../assets/img/banners_parceiros_main_slider/logos-parceiros/antarte.jpg';
import imgArtisaniLogo from '../assets/img/banners_parceiros_main_slider/logos-parceiros/artisani.jpg';
import imgChiccoLogo from '../assets/img/banners_parceiros_main_slider/logos-parceiros/chicco.jpg';
import imgMercadaoLogo from '../assets/img/banners_parceiros_main_slider/logos-parceiros/mercadao.jpg';
import imgPokeHouseLogo from '../assets/img/banners_parceiros_main_slider/logos-parceiros/poke-house.png';

import imgAdsOne from '../assets/img/parceiros_homepage_last_slider/desktop_1.png';
import imgAdsTwo from '../assets/img/parceiros_homepage_last_slider/desktop_2.png';
import imgAdsThree from '../assets/img/parceiros_homepage_last_slider/desktop_3.png';
import imgAdsFour from '../assets/img/parceiros_homepage_last_slider/desktop_4.png';
import imgAdsFive from '../assets/img/parceiros_homepage_last_slider/desktop_5.png';
import imgAdsOneMobile from '../assets/img/parceiros_homepage_last_slider/mobile_1.png';
import imgAdsTwoMobile from '../assets/img/parceiros_homepage_last_slider/mobile_2.png';
import imgAdsThreeMobile from '../assets/img/parceiros_homepage_last_slider/mobile_3.png';
import imgAdsFourMobile from '../assets/img/parceiros_homepage_last_slider/mobile_4.png';
import imgAdsFiveMobile from '../assets/img/parceiros_homepage_last_slider/mobile_5.png';
import imgAdsOneTablet from '../assets/img/parceiros_homepage_last_slider/tablet_1.png';
import imgAdsTwoTablet from '../assets/img/parceiros_homepage_last_slider/tablet_2.png';
import imgAdsThreeTablet from '../assets/img/parceiros_homepage_last_slider/tablet_3.png';
import imgAdsFourTablet from '../assets/img/parceiros_homepage_last_slider/tablet_4.png';
import imgAdsFiveTablet from '../assets/img/parceiros_homepage_last_slider/tablet_5.png';
import iconRestaurant from '../assets/svg/iconRestaurant.svg';
import iconStore from '../assets/svg/iconStore.svg';
import iconBeautyStore from '../assets/svg/iconBeautyStore.svg';
import iconEducation from '../assets/svg/iconEducation.svg';
import iconCultureLeisure from '../assets/svg/iconCultureLeisure.svg';
import iconSport from '../assets/svg/iconSport.svg';
import iconTech from '../assets/svg/iconTech.svg';
import iconModaHome from '../assets/svg/iconModaHome.svg';
import iconAnimals from '../assets/svg/iconAnimals.svg';
import iconCarsTransp from '../assets/svg/iconCarsTransp.svg';
import iconOther from '../assets/svg/iconOther.svg';
import iconAccomodationTravel from '../assets/svg/iconAccomodationTravel.svg';
import iconSustainability from '../assets/svg/iconSustainability.svg';
//add icons novos

const useCodes = () => {

    // -----------------------------------------------
    // PAYMENT TYPES
    // -----------------------------------------------

    // Codes 
    const paymentType = {
        movements: "M",
        pending: "P",
    }

    // List and configuration
    const paymentTypeList = [
        {
            id: paymentType.movements,
            title: "Movimentos",
        },
        {
            id: paymentType.pending,
            title: "Pendentes",
        },
    ]

    // Get Payment by id
    const getPaymentType = id => {
        return paymentTypeList.find(method => method.id === id);
    }


    // -----------------------------------------------
    // PAYMENT STATUS
    // -----------------------------------------------

    // Codes
    const paymentStatus = {
        amountMovements: 'A',
        amountPending: 'N',
        amountDeduction: 'U',
        amountRefunding: 'D',
        amountDeductionPending: 'C',
        transferPending: 'N',
        transferCompleted: 'P',
        transferCancelled: 'S',
        transferUnauthorised: 'E'
    }

    // List and labels
    const paymentStatusList = [
        {
            id: paymentStatus.amountMovements,
            iTransferencia: 'N',
            title: "Acumulação",
            color: '#E6FAE4',
            iconColor: '#15D4B6',
            txtAlert: {
                stepOne: 'Acumulação',
                stepTwo: 'Valor acrescentado ao saldo da sua Carteira Virtual.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Fez uma compra no parceiro',
                stepTwo: 'e tem uma',
                stepThree: 'de',
                stepFour: 'na sua Carteira Virtual.',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: 'Acumulou',
                stepTwo: 'e tem uma',
                stepThree: 'de',
                stepFour: 'com o código',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Recebeu de volta',
                stepTwo: '',
                stepThree: 'de',
                stepFour: 'pelo cancelamento ou devolução da encomenda',
                stepFive: 'do Marketplace Médis.',
            },
        },
        {
            id: paymentStatus.amountPending,
            iTransferencia: 'N',
            title: "Acumulação pendente",
            iTransferencia: 'N',
            color: '#FFEDC2',
            iconColor: '#FFB300',
            txtAlert: {
                stepOne: 'Acumulação pendente',
                stepTwo: 'Este valor estará disponível no seu saldo nas próximas 48 horas.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Fez uma compra no parceiro',
                stepTwo: 'e tem uma',
                stepThree: 'de',
                stepFour: '.',
                stepFive: 'Acumulação de saldo pendente',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: '',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Recebeu de volta',
                stepTwo: '',
                stepThree: 'de',
                stepFour: 'pelo cancelamento ou devolução da encomenda',
                stepFive: 'do Marketplace Médis.',
            },
        },
        {
            id: paymentStatus.amountDeduction,
            iTransferencia: 'N',
            title: "Dedução",
            color: '#D1F4F8',
            iconColor: '#40D0E2',
            txtAlert: {
                stepOne: 'Dedução',
                stepTwo: 'Valor retirado do saldo da sua Carteira Virtual.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Tem uma utilização',
                stepTwo: 'pendente',
                stepThree: 'de',
                stepFour: 'da sua Carteira Virtual.',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: '',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Gastou',
                stepTwo: '',
                stepThree: 'de',
                stepFour: 'na encomenda',
                stepFive: 'do Marketplace Médis.',
            },
        },
        {
            id: paymentStatus.amountDeduction,
            iTransferencia: 'N',
            movCodigo: "900",
            title: "Expiração",
            color: '#D1F4F8',
            iconColor: '#40D0E2',
            txtAlert: {
                stepOne: 'Expiração',
                stepTwo: 'Saldo expirado da sua Carteira Virtual.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Tem uma utilização',
                stepTwo: 'pendente',
                stepThree: 'de',
                stepFour: 'da sua Carteira Virtual.',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: '',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Expiraram',
                stepTwo: '',
                stepThree: '',
                stepFour: 'de saldo da sua Carteira Virtual após 18 meses sem utilização.',
                stepFive: '',
            },
        },
        {
            id: paymentStatus.amountRefunding,
            iTransferencia: 'N',
            title: "Devolução",
            color: 'transparent',
            iconColor: '#15D4B6',
            txtAlert: {
                stepOne: 'Devolução',
                stepTwo: 'Este valor estará Anuládo no seu saldo nas próximas 48 horas.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Fez uma devolução em',
                stepTwo: 'e anulámos a acumulação',
                stepThree: 'de',
                stepFour: 'na sua Carteira Virtual.',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: '',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Recebeu de volta',
                stepTwo: '',
                stepThree: 'de',
                stepFour: 'pelo cancelamento ou devolução da encomenda',
                stepFive: 'do Marketplace Médis.',
            },
        },
        {
            id: paymentStatus.amountDeductionPending,
            iTransferencia: 'N',
            title: "Dedução pendente",
            color: '#FFEDC2',
            iconColor: '#FFB300',
            txtAlert: {
                stepOne: 'Dedução pendente',
                stepTwo: 'Este valor será retirado do seu saldo nas próximas 48 horas.',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Tem uma ',
                stepTwo: 'Dedução pendente',
                stepThree: 'de',
                stepFour: 'da sua Carteira Virtual.',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: '',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Gastou',
                stepTwo: '',
                stepThree: 'de',
                stepFour: 'na encomenda',
                stepFive: 'do Marketplace Médis.',
            },
        },
        {
            id: paymentStatus.transferPending,
            iTransferencia: 'S',
            title: "Transferência pendente",
            color: '#D1F4F8',
            iconColor: '#40D0E2',
            subTitleDesc: 'A transferência é feita após a boa cobrança do próximo recibo de pagamento do seu seguro.',
            txtBottomInfo: '',
            txtAlert: {
                stepOne: '',
                stepTwo: '',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'A transferência é feita no máximo até 15 dias úteis após a boa cobrança do próximo recibo de pagamento do seguro.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: 'A transferência é feita no máximo até 15 dias úteis após a boa cobrança do próximo recibo de pagamento do seguro.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'A transferência é feita no máximo até 15 dias úteis após a boa cobrança do próximo recibo de pagamento do seguro.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            }
        },
        {
            id: paymentStatus.transferCompleted,
            iTransferencia: 'S',
            title: "Transferência aceite",
            color: '#E6FAE4',
            iconColor: '#15D4B6',
            subTitleDesc: '',
            txtBottomInfo: '',
            txtAlert: {
                stepOne: '',
                stepTwo: '',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi aceite e poderá demorar até 15 dias úteis. Se tiver dúvidas, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi aceite e poderá demorar até 15 dias úteis. Se tiver dúvidas, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi aceite e poderá demorar até 15 dias úteis. Se tiver dúvidas, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            }
        },
        {
            id: paymentStatus.transferCancelled,
            iTransferencia: 'S',
            title: "Transferência cancelada",
            color: '#FADBDB',
            iconColor: '#DE2121',
            subTitleDesc: 'Esta transferência no seu Prémio só terá efeito a partir da próxima renovação do seu seguro',
            txtBottomInfo: '',
            txtAlert: {
                stepOne: '',
                stepTwo: '',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'Não foi enviado saldo da Carteira para a sua conta bancária.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: 'Não foi enviado saldo da Carteira para a sua conta bancária.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'Não foi enviado saldo da Carteira para a sua conta bancária.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            }
        },
        {
            id: paymentStatus.transferUnauthorised,
            iTransferencia: 'S',
            title: "Transferência não autorizada",
            color: '#FADBDB',
            iconColor: '#DE2121',
            subTitleDesc: '',
            txtBottomInfo: '',
            txtAlert: {
                stepOne: '',
                stepTwo: '',
            },
            txtDetalheDeMovimentos: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi cancelada. Por favor, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            },
            txtDetalheDeMovimentosCupao: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi cancelada. Por favor, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
            },
            txtDetalheDeMovimentosMP: {
                stepOne: 'A transferência do saldo para a sua conta bancária foi cancelada. Por favor, contacte-nos através do 210 204 887 (dias úteis 9h-18h) ou marketplace@saude360.medis.pt para verificarmos a situação.',
                stepTwo: '',
                stepThree: '',
                stepFour: '',
                stepFive: '',
            }
        }
    ]

    // Get status object by id

    const getPaymentStatus = (id, iTransferencia, movCodigo) => {
        return paymentStatusList.find(method =>
            method.id === id && method.iTransferencia === iTransferencia && (method.movCodigo === movCodigo || (!method.movCodigo && movCodigo !== "900"))
        );
    };




    // -----------------------------------------------
    // ADS IMAGEM
    // -----------------------------------------------

    // Codes 
    const imageAdsNum = {
        one: "1",
        two: "2",
        three: "3",
    }

    // List and configuration
    const imageAdsNumList = [
        {
            id: imageAdsNum.one,
            img: {
                desktop: imgAntarteDesktop,
                tablet: imgAntarteTablet,
                mobile: imgAntarteMobile
            },
            logo: imgAntarteLogo,
        },
        {
            id: imageAdsNum.two,
            img: {
                desktop: imgChiccoDesktop,
                tablet: imgChiccoDesktop,
                mobile: imgChiccoDesktop
            },
            logo: imgChiccoLogo,
        },
        {
            id: imageAdsNum.three,
            img: {
                desktop: imgPokeHouseDesktop,
                tablet: imgPokeHouseTablet,
                mobile: imgPokeHouseMobile
            },
            logo: imgPokeHouseLogo,
        },
    ]

    // Get Image by id
    const getImageAdsNum = id => {
        return imageAdsNumList.find(method => method.id === id);
    }

    // -----------------------------------------------
    // ADS IMAGEM SEC
    // -----------------------------------------------

    // Codes 
    const imageAdsNumSec = {
        one: "1",
        two: "2",
        three: "3",
    }

    // List and configuration
    const imageAdsNumSecList = [
        {
            id: imageAdsNumSec.one,
            img: {
                desktop: imgArtisaniDesktop,
                tablet: imgArtisaniDesktop,
                mobile: imgArtisaniDesktop
            },
            logo: imgArtisaniLogo,
        },
        {
            id: imageAdsNumSec.two,
            img: {
                desktop: imgChiccoDesktop,
                tablet: imgChiccoDesktop,
                mobile: imgChiccoDesktop
            },
            logo: imgChiccoLogo,
        },
        {
            id: imageAdsNumSec.three,
            img: {
                desktop: imgMercadaoDesktop,
                tablet: imgMercadaoDesktop,
                mobile: imgMercadaoDesktop
            },
            logo: imgMercadaoLogo,
        },
    ]

    // Get Image by id
    const getImageAdsNumSec = id => {
        return imageAdsNumSecList.find(method => method.id === id);
    }

    // -----------------------------------------------
    // ADS SECOND IMAGEM
    // -----------------------------------------------

    // Codes 
    const secondImageAdsNum = {
        one: "1",
        two: "2",
        three: "3",
        four: "4",
        five: "5"
    }

    // List and configuration
    const secondImageAdsNumList = [
        {
            id: secondImageAdsNum.one,
            img: {
                desktop: imgAdsOne,
                tablet: imgAdsOneTablet,
                mobile: imgAdsOneMobile
            },
        },
        {
            id: secondImageAdsNum.two,
            img: {
                desktop: imgAdsTwo,
                tablet: imgAdsTwoTablet,
                mobile: imgAdsTwoMobile
            },
        },
        {
            id: secondImageAdsNum.three,
            img: {
                desktop: imgAdsThree,
                tablet: imgAdsThreeTablet,
                mobile: imgAdsThreeMobile
            },
        },
        {
            id: secondImageAdsNum.four,
            img: {
                desktop: imgAdsFour,
                tablet: imgAdsFourTablet,
                mobile: imgAdsFourMobile
            },
        },
        {
            id: secondImageAdsNum.five,
            img: {
                desktop: imgAdsFive,
                tablet: imgAdsFiveTablet,
                mobile: imgAdsFiveMobile
            },
        },
    ]

    // Get Second Image by id
    const getSecondImageAdsNum = id => {
        return secondImageAdsNumList.find(method => method.id === id);
    }

    // -----------------------------------------------
    // ICON TYPE
    // -----------------------------------------------

    // Codes 
    const iconType = {
        restaurant: "Restauração e Supermercado",
        beautyStore: "Saúde e Beleza",
        education: "Crianças e Educação",
        cultureLeisure: "Cultura e Lazer",
        sport: "Desporto e Nutrição",
        tech: "Tecnologia",
        modaHome: "Moda e Casa",
        animals: "Animais",
        carsTransp: "Mobilidade",
        accomodationTravel: "Alojamento e Viagens",
        sustainability: "Sustentabilidade",
        other: "Outros",
        //add category aqui
        store: "Supermercados"

    }

    // List and configuration
    const iconTypeList = [
        {
            id: iconType.restaurant,
            img: iconRestaurant,
        },
        {
            id: iconType.store,
            img: iconStore,
        },
        {
            id: iconType.beautyStore,
            img: iconBeautyStore,
        },
        {
            id: iconType.education,
            img: iconEducation,
        },
        {
            id: iconType.cultureLeisure,
            img: iconCultureLeisure,
        },
        {
            id: iconType.sport,
            img: iconSport,
        },
        {
            id: iconType.tech,
            img: iconTech,
        },
        {
            id: iconType.modaHome,
            img: iconModaHome,
        },
        {
            id: iconType.animals,
            img: iconAnimals,
        },
        {
            id: iconType.carsTransp,
            img: iconCarsTransp,
        },
        {
            id: iconType.accomodationTravel,
            img: iconAccomodationTravel,
        },
        {
            id: iconType.sustainability,
            img: iconSustainability,
        },
        {
            id: iconType.other,
            img: iconOther,
        },
        //add obj de categoria aqui c link p img.
    ]

    // Get Icon by id
    const getIconType = id => {
        return iconTypeList.find(method => method.id === id);
    }

    // -----------------------------------------------
    // DEDUCAO STATUS
    // -----------------------------------------------

    // Codes
    const deducaoStatus = {
        deductionProcessed: 'P',
        deductionExpired: 'S',
        deductionPending: 'N',
    }

    // List and labels
    const deducaoStatusList = [
        {
            id: deducaoStatus.deductionPending,
            title: "Transferência pendente",
            color: '#D1F4F8',
            iconColor: '#40D0E2',
            subTitleDesc: 'A transferência de saldo é feita apenas após a boa cobrança do recibo do seguro.',
            txtBottomInfo: 'Pode demorar até 15 dias úteis a receber o montante.'
        },
        {
            id: deducaoStatus.deductionProcessed,
            title: "Transferência processada",
            color: '#E6FAE4',
            iconColor: '#15D4B6',
            subTitleDesc: 'A transferência de saldo é feita apenas após a boa cobrança do recibo do seguro.',
            txtBottomInfo: 'Pode demorar até 15 dias úteis a receber o montante.'
        },
        {
            id: deducaoStatus.deductionExpired,
            title: "Transferência expirada",
            color: '#FADBDB',
            iconColor: '#DE2121',
            subTitleDesc: 'A transferência de saldo é feita apenas após a boa cobrança do recibo do seguro.',
            txtBottomInfo: 'Pode demorar até 15 dias úteis a receber o montante.'
        },
    ]

    // Get status object by id
    const getDeducaoStatus = id => {
        return deducaoStatusList.find(method => method.id === id);
    }

    return {
        paymentType,
        paymentStatus,
        paymentTypeList,
        paymentStatusList,
        getPaymentType,
        getPaymentStatus,
        imageAdsNum,
        imageAdsNumList,
        getImageAdsNum,
        imageAdsNumSec,
        imageAdsNumSecList,
        getImageAdsNumSec,
        secondImageAdsNum,
        secondImageAdsNumList,
        getSecondImageAdsNum,
        iconType,
        iconTypeList,
        getIconType,
        deducaoStatus,
        deducaoStatusList,
        getDeducaoStatus
    };
};


export default useCodes;